"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _useStyles = _interopRequireDefault(require("./useStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Authorities = function Authorities(_ref) {
  var title = _ref.title,
      logos = _ref.logos;
  var classes = (0, _useStyles["default"])();
  return /*#__PURE__*/_react["default"].createElement(_core.Box, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "h4"
  }, title), logos.map(function (logo, i) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: logo.to,
      className: classes.logoWrapper,
      key: logo.alt ? logo.alt.concat(i) : "imgKey".concat(i)
    }, /*#__PURE__*/_react["default"].createElement(_gatsbyImage["default"], _extends({
      imgStyle: {
        objectFit: 'contain'
      },
      className: classes.logo,
      objectFit: "contain"
    }, logo, {
      target: "_blank",
      rel: "noreferrer"
    })));
  }));
};

Authorities.defaultProps = {
  title: ''
};
Authorities.propTypes = {
  title: _propTypes["default"].string,
  // eslint-disable-next-line react/forbid-prop-types
  logos: _propTypes["default"].array.isRequired
};
var _default = Authorities;
exports["default"] = _default;